import TextField from "@mui/material/TextField";
import React from "react";
import './SearchField.scss'
import ColorNumber from "../ColorNumber/ColorNumber";
import {stockDetailsUrl} from "../../Route_urls";
import {Link} from "react-router-dom";
import CountryFlag from "../CountryFlag/CountryFlag";
import Spacer from "../Spacer";


const SearchField = ({onChange, searchText, dropdownResults, showDropdownResults = false}) => {
    const showDropdownResultTable = showDropdownResults && dropdownResults && dropdownResults.length > 0
    const onEnter = (e) => {
        if (e.key === "Enter") {
            e.target.blur();
        }
    };


    
    return (
        <>
            <TextField InputLabelProps={{
                style: {
                    color: 'black', width: '90%',
                }
            }} style={{
                backgroundColor: "",

            }}
                       InputProps={{
                           style: {
                               color: "black",
                           }
                       }}
                       fullWidth onChange={onChange} onKeyUp={onEnter} enterKeyHint="go"
                       label="Search stock by name or symbol"
                       variant="outlined"
                       value={searchText}/>
            {showDropdownResultTable &&
                <div className="relative overflow-x-auto">
                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                        <thead
                            className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">
                                Name
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Ticker
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Change %
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Price
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {dropdownResults && dropdownResults.map(({node: stock, index}) => (


                            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">

                                <th scope="row"
                                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white font-bold	">
                                    {/*  <img className="w-10 h-10 rounded-full" src="/docs/images/people/profile-picture-2.jpg"
                                     alt="Jese image"/>
                                 */}
                                    <Link key={index} to={`${stockDetailsUrl}/${stock.slug}`}
                                          state={{stockData: stock}}>
                                        <div style={{display: "flex"}}>
                                            <CountryFlag
                                                countryName={stock.profileId.country} height='15px'/>
                                            <Spacer
                                                axis="horizontal" size={5}/>
                                            {stock.fullName}


                                        </div>


                                    </Link>
                                </th>
                                <td className="px-6 py-4 font-bold	">
                                    {stock.profileId.ticker}
                                </td>
                                <td className="px-6 py-4">
                                    <ColorNumber number={stock.profileId.changePercentageLastDay}
                                                 endSign={'%'}/>
                                </td>
                                <td className="px-6 py-4 font-bold	">
                                    {stock.profileId.currentPrice} {stock.profileId.currency}
                                </td>

                            </tr>

                        ))}

                        </tbody>

                    </table>
                </div>
            }
        </>


    )
}

export default SearchField